import React from 'react'

import { NewCupon } from '../../../types'

import { ModalRow } from './styles'

const ALL_OPTIONS = [1, 2, 4, 6, 8]

const Classes = ({
  amountOfClasses,
  handleMenuChange,
  studentHasActiveBonus,
}: {
  amountOfClasses: number
  handleMenuChange: <K extends keyof NewCupon>(
    key: K,
    value: NewCupon[K],
  ) => void
  studentHasActiveBonus: boolean
}) => {
  const options = studentHasActiveBonus ? [1] : ALL_OPTIONS

  return (
    <ModalRow>
      <div className="title">Tipo de Bono</div>
      <div className="menu">
        {options.map((value) => (
          <div
            key={value}
            className={`menu-item ${amountOfClasses === value ? 'active' : ''}`}
            onClick={() => handleMenuChange('amountOfClasses', value)}
          >
            {value} {value === 1 ? 'Clase' : 'Clases'}
          </div>
        ))}
      </div>
    </ModalRow>
  )
}

export default Classes
